(()=>{
  const mount=()=>{
    if(!window.matchMedia('(min-width:800px)').matches)return;
    const section=document.querySelector('.ld66-desktop-artists');
    if(!section)return;
    const heading=section.querySelector('.ld66-desktop-heading--light');
    const title=heading?.querySelector('#ld66-desktop-artists-title');
    if(!heading||!title)return;

    title.textContent='REGARD CONTEMPORAIN';
    const kicker=heading.querySelector('.ld66-desktop-kicker');
    if(kicker){
      kicker.textContent='ARTISTES';
      kicker.removeAttribute('aria-hidden');
    }

    const old=heading.querySelector('.ld66-desktop-artists-motion');
    if(old)old.remove();
    const motion=document.createElement('div');
    motion.className='ld66-desktop-artists-motion';
    motion.setAttribute('aria-hidden','true');
    motion.innerHTML='<video autoplay muted loop playsinline preload="metadata" tabindex="-1"><source src="https://shopify66.b-cdn.net/wp-content/Teaser/TEASER%20LA%20DISTILLERIE%2066.mp4" type="video/mp4"></video>';
    heading.prepend(motion);
    const video=motion.querySelector('video');
    if(video){video.muted=true;video.play().catch(()=>{});}
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
})();
